import { AxiosError } from 'axios';
import { useAuth } from 'hooks';
import { QueryKeys } from 'queries';
import { useQuery, UseQueryOptions } from 'react-query';

import apiService from 'services/api/ApiService';
import { GameTeaser } from 'services/api/definitions/collections.definitions';

export const useFavorites = (
  options: UseQueryOptions<GameTeaser[], AxiosError> = { enabled: true },
) => {
  const { isLoggedIn } = useAuth();
  const {
    data: games,
    isLoading,
    error,
  } = useQuery(QueryKeys.allgames.favorites(), () => apiService.getFavoriteGames(), {
    ...options,
    enabled: isLoggedIn && options.enabled,
  });

  return {
    isLoading,
    hasError: !!error,
    games,
    isEmpty: !isLoading && !!games && games.length === 0,
  };
};
